import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SingleClient from './Components/Clients/SingleClient';
import Settings from './Components/Settings';

class Content extends Component {

    render() {


        return <div className="content">
            <Switch>

                {/* <Route path="/planning" component={FreelancerPlanning} />
                <Route path="/bookings" component={Bookings} /> */}
                <Route path="/settings" component={Settings} />
                <Route path="/:start?/:end?" component={SingleClient} />
              
                {/* <Route path="/clients" component={Clients} /> */}
             


            </Switch>
              
            
        </div>

    }
}

export default Content;